import React, { useState, useEffect, useCallback } from "react";
import { Label, Spinner } from "flowbite-react";
import toast from "react-hot-toast";
import Backend from "../../../../Backend/Backend";
import Mousetrap from "mousetrap";

const backend = await new Backend().init();

export default function CreatePayment({ master_id, userType }) {
  const [loading, setLoading] = useState(false);

  const [account_name, setAccountName] = useState("");
  const [account_number, setAccountNumber] = useState("");
  const [account_ifsc, setAccountIfsc] = useState("");
  const [account_type, setAccountType] = useState("");
  const [bank_name, setBankName] = useState("");
  const [upi_id, setUpiId] = useState("");
  const [qr_name, setQrName] = useState("");

  const onCreate = useCallback(async () => {
    if (!account_name && !upi_id) {
      toast.error("Please provide Bank Details or UPI ID");
      return;
    }

    setLoading(true);

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
      username: localStorage.getItem("username"),
      master_id: userType === 3 ? localStorage.getItem("id") : master_id,

      account_name,
      account_number,
      account_ifsc,
      account_type,
      bank_name,
      upi_id,
      qr_name,
    };

    try {
      const r = await backend.add_bank_account(data);

      if (r.error === "False") {
        toast.success(r.message);
        setAccountName("");
        setAccountNumber("");
        setAccountIfsc("");
        setAccountType("");
        setBankName("");
        setUpiId("");
        setQrName("");
      } else {
        toast.error(r.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  }, [
    account_name,
    account_number,
    account_ifsc,
    account_type,
    bank_name,
    upi_id,
    qr_name,
    master_id,
    userType,
  ]);

  // 🔥 Press Enter to Submit
  useEffect(() => {
    Mousetrap.bind("enter", onCreate);
    return () => Mousetrap.unbind("enter", onCreate);
  }, [onCreate]);

  return (
    <div className="max-w-2xl mx-auto bg-white dark:bg-gray-800 shadow-xl rounded-2xl p-6 space-y-6">
      <h2 className="text-xl font-semibold text-gray-800 dark:text-white">
        Add Payment Details
      </h2>

      {/* Bank Details Section */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <InputField
          label="Account Name"
          value={account_name}
          onChange={setAccountName}
          placeholder="Enter Account Name"
        />

        <InputField
          label="Account Number"
          value={account_number}
          onChange={setAccountNumber}
          placeholder="Enter Account Number"
        />

        <InputField
          label="IFSC Code"
          value={account_ifsc}
          onChange={setAccountIfsc}
          placeholder="Enter IFSC Code"
        />

        <InputField
          label="Account Type"
          value={account_type}
          onChange={setAccountType}
          placeholder="Savings / Current"
        />

        <InputField
          label="Bank Name"
          value={bank_name}
          onChange={setBankName}
          placeholder="Enter Bank Name"
        />

        <InputField
          label="UPI ID"
          value={upi_id}
          onChange={setUpiId}
          placeholder="example@upi"
        />

        <InputField
          label="QR Name"
          value={qr_name}
          onChange={setQrName}
          placeholder="QR Display Name"
        />
      </div>

      {/* Submit Button */}
      <button
        onClick={onCreate}
        disabled={loading}
        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 rounded-lg transition-all flex justify-center items-center disabled:opacity-70"
      >
        {loading ? <Spinner size="sm" /> : "Save Details"}
      </button>
    </div>
  );
}

/* ================= Reusable Input ================= */

function InputField({ label, value, onChange, placeholder }) {
  return (
    <div>
      <Label value={label} />
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="mt-1 w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 dark:text-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
      />
    </div>
  );
}
